<template>
 
  <div>
    <div class="item" style="width: 275px !important;">
      <div class="item__header">
        <div class="item__header__discount">
          <div class="sticker sticker-top sticker-shock item__header__sticker">
            <NuxtLink
              class="text-dark"
              :to="{
                name: 'vesti-title',
                params: { title: srbTolatPath(titleWithDate(product)) }
              }"
            >
              {{ product?.product }} 
            </NuxtLink>
          </div>
        </div>

        <div class="item__header__favorite"></div>
      </div>

      <NuxtLink
        :to="{
          name: 'vesti-title',
          params: { title: srbTolatPath(titleWithDate(product)) }
        }"
      >
        <div class="item__image-ad">
          <NuxtImg
            v-if="!imageError"
            :src="processedUrl(product)"
            :alt="product?.img"
            @error="onImageError"
            class="img-ads-br"
            style="max-width: 85px"
            loading="lazy"
          />

          <NuxtImg
            v-else
            src="https://pijace.com/api/img/markets/default.webp"
            :alt="product?.img"
            class="img-ads-br"
            style="max-width: 85px"
          />
        </div>

        <div class="item__name mt-2 mb-0">
          <h4>{{ titleWithDate(product) }}</h4>
        </div>
      </NuxtLink>

      <div class="item__ratings item__rating__ad">
        <p>
          <i class="esei icon-map-marker place-icon-color-ads font-size-11"></i>
          {{ product?.producer }}
        </p>
      </div>

      <div class="item__bottom">
        <NuxtLink
          :to="{
            name: 'vesti-title',
            params: { title: srbTolatPath(titleWithDate(product)) }
          }"
        >
          <div class="item__bottom__prices">
            <div class="item__bottom__prices__old"></div>

            <div class="item__bottom__prices__price text-dark">
              {{ product?.price }}
              <span class="font-size-15">
                {{ product?.unit }}
              </span>
            </div>

            <div class="item__bottom__prices__saving text-dark">
              {{ formattedDate(product) }}
            </div>
          </div>
        </NuxtLink>

        <div class="item__bottom__cart">
          <!-- kupi dugme (ostavljeno kao komentar kao i kod tebe) -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
 

const props = defineProps({
  product: { type: Object, required: true },
  layout: { type: String, default: '' }
})

const dayjs = useDayjs()
const { $srbTolat } = useNuxtApp()

const imageError = ref(false)

const srbTolatPath = (text) => {
  if ($srbTolat?.srbTolatPath) return $srbTolat.srbTolatPath(String(text ?? ''))
  return String(text ?? '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
}

const processedUrl = (product) => {
  const cover = String(product?.cover_img ?? '')
  if (cover.includes('img/markets')) {
    return `https://pijace.com/api${cover}.webp`
  }
  return String(product?.img ?? 'https://pijace.com/api/img/markets/default.webp')
}

const titleWithDate = (product) => {
  const title = String(product?.title ?? '')
  const date = product?.date
  const formatted = date ? dayjs(date).format('DD.MM.YYYY') : ''
  
  return `${title} ${formatted}`.trim()
}

const formattedDate = (product) => {
  const date = product?.date
  return date ? dayjs(date).format('DD.MM.YYYY') : ''
}

const onImageError = () => {
  imageError.value = true
}

const convertToLocale = (number) => {
  return new Intl.NumberFormat('sr-RS', {
    style: 'currency',
    currency: 'RSD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(number))
}
</script>
